import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API_BASE, apiError } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { CompanyLogo } from "@/components/CompanyLogo";
import { PoweredBy } from "@/components/PoweredBy";
import { StatusBadge } from "@/components/StatusBadge";
import { PublicLoading, PublicError } from "@/pages/public/VisitorRegister";

export default function VisitorPass() {
  const { token } = useParams();
  const [p, setP] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    axios.get(`${API_BASE}/public/visitor/pass/${token}`).then((r) => setP(r.data)).catch((e) => setErr(apiError(e)));
  }, [token]);

  if (err) return <PublicError title="Pass Not Found" message={err} />;
  if (!p) return <PublicLoading />;

  const rows = [
    ["Company", p.visitor_company], ["Phone", p.visitor_phone],
    ["Meeting", p.person_to_meet], ["Cabin", p.cabin_number],
    ["Branch", p.branch], ["Date", p.visit_date], ["Time", p.visit_time],
  ];

  return (
    <div className="min-h-screen sf-grid-bg flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-2xl overflow-hidden sf-fade-up" data-testid="visitor-pass-card">
        <div className="bg-navy-900 text-white p-6">
          <div className="flex items-center justify-between">
            <Logo className="h-6" light />
            <span className="text-[10px] font-mono px-2 py-1 rounded-full bg-white/10">VISITOR PASS</span>
          </div>
          <h1 className="font-display text-3xl font-bold mt-4">{p.visitor_name}</h1>
          <p className="text-blue-200/80 text-sm">{p.company}</p>
        </div>
        <div className="p-6 flex flex-col items-center">
          {p.logo_url && <CompanyLogo logoUrl={p.logo_url} className="h-10 mb-4" alt={p.company} />}
          <img src={p.qr} alt="Pass QR" className="w-44 h-44" data-testid="pass-qr" />
          <div className="mt-3"><StatusBadge status={p.status} /></div>
        </div>
        <div className="px-6 pb-6 grid grid-cols-2 gap-x-4 gap-y-3">
          {rows.map(([k, v]) => (
            <div key={k}>
              <p className="text-[11px] uppercase tracking-wide text-slate-400 font-semibold">{k}</p>
              <p className="text-sm font-semibold text-navy-900">{v || "—"}</p>
            </div>
          ))}
        </div>
        <div className="bg-slate-50 px-6 py-3 text-center border-t border-slate-100">
          <p className="text-[11px] text-slate-400">Present this pass at reception</p>
          <PoweredBy className="mt-1.5" />
        </div>
      </div>
    </div>
  );
}
